module.exports = __webpack_public_path__ + "static/media/GothamCond-Medium.f9833e3e.otf";